import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authLoginURL } from "../../constants/urls";

export const Signin = () => {
  const [params] = useSearchParams();
  const code = params.get("code") ?? "";
  const navigate = useNavigate();

  useEffect(() => {
    if (code !== "") {
      navigate(`/authorize-user?code=${code}`);
    }
  }, [code, navigate]);

  return code !== "" ? <div /> : <RedirectToLoginComponent />;
};

const RedirectToLoginComponent = () => {
  const { t } = useTranslation();
  const scope = "auth_app";
  const state = "2";
  const responseType = "code";
  const redirectUri = `${window.location.protocol}//${window.location.host}/signin`;

  const authUrl = `${authLoginURL}authorize?redirect_uri=${redirectUri}&state=${state}&scope=${scope}&response_type=${responseType}`;

  window.location.replace(authUrl);
  return <>{t("redirectingToLoginPage")}</>;
};
